// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".adm-password[data-v-1fbdccda]{display:flex;gap:8px}.adm-password__box[data-v-1fbdccda]{position:relative;flex:1;min-width:0}.adm-password__input[data-v-1fbdccda]{padding-right:44px}.adm-password__toggle[data-v-1fbdccda]{position:absolute;right:4px;top:50%;transform:translateY(-50%);width:32px;height:32px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
